import { Context } from '@nuxt/types'
import { BibleBookApi } from '~/apiclient/apibible'
import { scriptureRootUrl, siteScriptureUrl } from '~/assets/ts/utils/urls'

export default async function ({ store, params, $redirectTo }: Context) {
  await store.dispatch('filters/getBible')
  const books = store.getters['filters/bible'] as BibleBookApi[]
  const { book, chapter, verse } = params
  const osis = book.toUpperCase()
  // If the user tried to go to an invalid url like /sermons/scripture/genesis, we'll
  // redirect them to /sermons/scripture/GEN
  if (osis.length !== 3) {
    const match = books.find((b) => {
      const titles = [b.displayTitle, b.title, b.blbAbbrev].map((t) =>
        t.toUpperCase()
      )
      return titles.includes(osis)
    })
    if (match) {
      $redirectTo(siteScriptureUrl(match.osisAbbrev, chapter, verse))
      return
    }
  }
  const bookApi = books.find((b) => b.osisAbbrev === osis)
  const ch = chapter ? parseInt(chapter) : undefined
  const vs = verse ? parseInt(verse) : undefined
  if (!bookApi) {
    $redirectTo(scriptureRootUrl)
  } else if (ch && ch > bookApi.chapters) {
    $redirectTo(siteScriptureUrl(osis))
  } else if (ch && vs && vs > bookApi.verses[ch - 1]) {
    $redirectTo(siteScriptureUrl(osis, ch))
  }
}
